import {MessageAlertService} from '../../services/message-alert/message-alert.service';
import {UtilitiesService} from '../../services/utilities-service/utilities.service';
import {Logger} from '../../class/helper/logger.class';
import {IRecordEmit} from '../../interfaces/record';
import {ActivatedRoute, Params} from '@angular/router';
import {Loader} from '../../models/loader/loader.redux';
import {cloneDeep} from 'lodash';
import {AfterViewInit, Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {Store} from '@ngxs/store';
import {firstValueFrom, Observable, Subscription} from 'rxjs';
import {
  IPhysicalExaminationSign,
  IPhysicalExaminationSignCategory,
  IRecordNutritionalPhysicalExamination,
  NutritionalPhysicalExaminationState,
  RecordNutritionalPhysicalExaminationAction
} from '../../models/record-nutritional-physical-examination';
import {StorageService} from '../../services/storage/storage.service';
import {ServiceAction, ServiceState} from '../../models/service';
import {AuthState, IUser} from '../../models/auth';
import {fadeInAnimation} from '../../animations/fade-in.animation';
import {SkeletonEnum} from '../../enums/skeleton';
import {SkeletonService} from '../../services/skeleton/skeleton.service';

@Component({
  selector: 'app-record-history-nutritional-physical-examination',
  templateUrl: './record-history-nutritional-physical-examination.component.html',
  styleUrls: ['./record-history-nutritional-physical-examination.component.scss'],
  animations: [fadeInAnimation]
})
export class RecordHistoryNutritionalPhysicalExaminationComponent implements OnInit, AfterViewInit {
  // tslint:disable:variable-name
  wasDeployed$: Observable<boolean> = this.store.select<boolean>(NutritionalPhysicalExaminationState.getWasDeployed);
  wasDeployedSubscription: Subscription;
  isPatient$: Observable<boolean> = this.store.select<boolean>(AuthState.getIsPatient);
  otherSigns = '';
  categories: IPhysicalExaminationSignCategory[] = [];

  serviceId: string;
  expertId: string;
  patientId: string;
  clinicId: string;

  userLogged: IUser;

  @Input() recordNutritionalPhysicalExamination: IRecordNutritionalPhysicalExamination;
  @Output() recordNutritionalPhysicalExaminationChange = new EventEmitter<IRecordEmit>();

  loadInfo: boolean;
  skeletonTemplate: any[] = [];
  signIds: string[] = [];
  disableForm = false;
  constructor(
    private store: Store,
    private storageService: StorageService,
    private activatedRoute: ActivatedRoute,
    public utilitiesService: UtilitiesService,
    public messageAlert: MessageAlertService,
    private skeletonService: SkeletonService,
  ) {
    this.wasDeployedSubscription = this.wasDeployed$.subscribe(value => {
      if (value && !this.recordNutritionalPhysicalExamination) {
        this.loadInfo = false;
        this.initValuesHttp();
      }
    });
  }

  ngOnInit(): void {
    this.skeletonTemplate = this.skeletonService.build(SkeletonEnum.ROWS);
  }

  initValues(): void {
  }

  /**
   * Lanza las peticiones iniciales necesarias al servidor.
   */
  async initValuesHttp(): Promise<void> {
    try {
      this.getParams();
      this.userLogged = this.storageService.getLocalItem<{ user: IUser, token: string }>('user')?.user;
      if (this.userLogged && this.userLogged.experts) {
        this.expertId = this.userLogged.experts[0]._id;
      } else if (this.userLogged && this.userLogged.patients) {
        const queryParams = this.activatedRoute.snapshot.queryParams;
        this.expertId = queryParams.expert;
      }
      this.serviceId = await firstValueFrom((this.store.selectOnce(ServiceState.getServiceSelectedId)));
      if (!this.serviceId) {
        await firstValueFrom((this.store.dispatch(new ServiceAction.GetActive(this.patientId, this.expertId))));
        this.serviceId = await firstValueFrom((this.store.selectOnce(ServiceState.getServiceSelectedId)));
      }
      await firstValueFrom((this.store.dispatch(new RecordNutritionalPhysicalExaminationAction.GetActive(this.serviceId, this.patientId))));
      const categories = cloneDeep(await firstValueFrom(this.store.selectOnce(NutritionalPhysicalExaminationState.getPhysicalExaminationSignCategories)));
      this.recordNutritionalPhysicalExamination =
        cloneDeep(await firstValueFrom((this.store.selectOnce(NutritionalPhysicalExaminationState.getNutritionalPhysicalExamination))));
      this.otherSigns = this.recordNutritionalPhysicalExamination.information;
      categories.forEach((category: IPhysicalExaminationSignCategory) => {
        this.categories.push({
          ...category,
          physicalExaminationSigns: category.physicalExaminationSigns ? category.physicalExaminationSigns.map((_sign) => {
            const existsSign = this.recordNutritionalPhysicalExamination.signs.find(item => item.signId === _sign._id);
            return {
              ..._sign,
              active: !!existsSign,
            };
          }) : category.physicalExaminationSigns ? category.physicalExaminationSigns.map((_disease) => {
            return {
              ..._disease,
              active: false,
            };
          }) : []
        });
      });
      this.signIds = this.recordNutritionalPhysicalExamination.signs.map(sign => sign.signId);
      // Bloquear campos para usuarios pacientes
      this.disableForm = !this.userLogged || !!this.userLogged?.patients;
      setTimeout(() => {
        this.loadInfo = true;
      });
      this.emitChangeUpdate();
    } catch (e) {
      Logger.log('Ocurrio un error', e);
    } finally {
      await firstValueFrom((this.store.dispatch(new Loader(false))));
    }
  }

  getParams(): void {
    const params: Params = this.utilitiesService.getAllParams(this.activatedRoute);
    this.clinicId = params.clinicId;
    this.patientId = params.patientId;
  }

  ngAfterViewInit(): void {
  }

  emitChangeUpdate(): void {
    if (!this.recordNutritionalPhysicalExamination) return;
    this.recordNutritionalPhysicalExamination.updatedAt = new Date().toISOString();
    this.recordNutritionalPhysicalExaminationChange.emit({ record: this.recordNutritionalPhysicalExamination, updated: true });
  }

  checkedSignChange(value: boolean, item: IPhysicalExaminationSign): void {
    if (value) {
      // se debe agregar a los datos de la ficha a guardar
      this.pushSign(item);
    } else {
      // se debe remover de los datos de la ficha a guardar
      this.removeSign(item);
    }
  }

  removeSign(sign: IPhysicalExaminationSign): void {
    const exists = this.signIds.findIndex(_sign => _sign === sign._id);
    if (exists !== -1) {
      this.signIds.splice(exists, 1);
    }
  }

  pushSign(sign: IPhysicalExaminationSign): void {
    const exists = this.signIds.find(_sign => _sign === sign._id);
    if (exists) return;
    this.signIds.push(sign._id);
  }

  async onSave(): Promise<void> {
    try {
      await firstValueFrom((this.store.dispatch(new Loader(true, 'Guardando datos ...'))));
      await firstValueFrom(this.store.dispatch(new RecordNutritionalPhysicalExaminationAction.PatchActive(
        this.serviceId, this.patientId, { signIds: cloneDeep(this.signIds), information: this.otherSigns })
      ));
      this.messageAlert.createMessage('success', 'Historial de exploración física nutricional guardado exitosamente.');
      this.emitChangeUpdate();
    } catch (e) {
      Logger.log('Ocurrio un error', e?.message);
      this.messageAlert.createMessage('error', 'Ha ocurrido un error al actualizar la ficha. Intente más tarde', 5000);
    } finally {
      await firstValueFrom((this.store.dispatch(new Loader(false))));
    }
  }
}
